import { calculateEffectivePurchase } from "../../../utils/utils";
import { ALLOWED_PURCHASE_STATUS } from "../../../components/components.constants";

const getSourceValue = (sourceObj, preferredSource, fallback) => {
  const sourceValue = sourceObj?.[preferredSource];
  return Number(fallback) === Number(sourceValue) ? fallback : sourceValue;
};

const calculateSuggestedValue = (source, preferredSource, fallback, packToUnitRatio) => {
  const sourceValue = getSourceValue(source, preferredSource, fallback);
  return calculateEffectivePurchase(sourceValue, packToUnitRatio) ?? 0;
};

const inputValueStrategy = ({ inputs, productId, colName }) => {
  const value = inputs?.[productId]?.[colName];
  return (value !== null && value !== undefined) ? value : null;
};

const orderHistoryStrategy = ({ row }) => {
  
  const calculateOrderHistoryValue = (row) => {

    if (!row) return 0;

    const { 
        packToUnitRatio,
        effectivePurchase,
        preferedSource,
    } = row?.original || {};

    if (!packToUnitRatio || !preferedSource) return effectivePurchase ?? 0;

    const sourceKey = typeof preferedSource === 'number' ? `purchaseRec${preferedSource}` : preferedSource;
    const sourceValue = row?.original[sourceKey];

    if (sourceValue === undefined || sourceValue === null) return effectivePurchase ?? 0;

    const expectedFromSource = calculateEffectivePurchase(sourceValue, packToUnitRatio);

    const firstCondition = Number(effectivePurchase) === Number(expectedFromSource);

    if (firstCondition) return expectedFromSource;
    return effectivePurchase ?? 0;
  };
    
    return calculateOrderHistoryValue(row);
};

const createPurchaseRecommendationStrategy = (source, config = {}) => {
  const {
    shouldUseEffectivePurchase = (ep) => ep > 0,
    defaultFallback = 0
  } = config;

  const handlers = {
    [ALLOWED_PURCHASE_STATUS.SUGGESTED]: () =>
      calculateSuggestedValue(
        source,
        source.preferedSource,
        source.initialPurchaseRecommendation,
        source.packToUnitRatio
      ),
    
    [ALLOWED_PURCHASE_STATUS.EDITED]: () => {
      const useExisting = shouldUseEffectivePurchase(source.effectivePurchase);
      
      if (useExisting) {
        return source.effectivePurchase;
      }
      
      return calculateSuggestedValue(
        source,
        source.preferedSource,
        source.initialPurchaseRecommendation,
        source.packToUnitRatio
      );
    }
  };

  const handler = handlers[source.purchaseStatus];
  return handler ? handler() : (source.effectivePurchase ?? defaultFallback);
};

const orderModalOnPurchaseRecommendationTableStrategy = ({ item }) => {
  return createPurchaseRecommendationStrategy(item, {
    shouldUseEffectivePurchase: (ep) => ep > 0,
    defaultFallback: 0
  });
};

const purchaseRecommendationTableStrategy = ({ row }) => {
  return createPurchaseRecommendationStrategy(row.original, {
    shouldUseEffectivePurchase: (ep) => ep !== 0,
    defaultFallback: row.original.effectivePurchase ?? 0
  });
};

export const createPurchaseValueStrategy = (data) => {
  const { isOrderHystoryPage, conditionValue } = data;

  const strategies = [
    {
      condition: () => inputValueStrategy(data) !== null,
      strategy: () => inputValueStrategy(data)
    },
    {
      condition: () => isOrderHystoryPage,
      strategy: () => orderHistoryStrategy(data)
    },
    {
      condition: () => conditionValue,
      strategy: () => orderModalOnPurchaseRecommendationTableStrategy(data)
    },
    {
      condition: () => true,
      strategy: () => purchaseRecommendationTableStrategy(data)
    }
  ];

  const selectedStrategy = strategies.find(({ condition }) => condition());
  return selectedStrategy.strategy();
};